import axios from 'axios';
import { getUserIdentity } from 'src/api/identity';
import { replaceString, reverseReplaceString } from 'src/api/demo';
import { SESSION_EXPIRE_CODE } from './useApi';
import { sweetAlertHandler } from '../../targetting/toaster';

const getAuthToken = () => JSON.parse(localStorage.getItem('User')) || {};

const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_HTTP_URL}/`,
  headers: {}
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      const authToken = getAuthToken();
      originalRequest.headers.Authorization = `Bearer ${authToken.token}`;

      return axiosInstance(originalRequest);
    }

    return Promise.reject(error);
  }
);
const getDspDetails = (selectedProfile, masterAccountFilter) => {
  if (!selectedProfile || !selectedProfile?.dsp || selectedProfile?.dsp?.length === 0) {
      return null;
  }

  if (
      masterAccountFilter &&
      selectedProfile?.profileId &&
      masterAccountFilter[selectedProfile?.profileId] &&
      masterAccountFilter[selectedProfile?.profileId].length > 0
  ) {
      const selectedDspId = masterAccountFilter[selectedProfile?.profileId]?.find((item) => item?.level === "dsp")?.keywords;
      const selectedDspAccount = selectedProfile?.dsp?.find((item) =>
          Array.isArray(selectedDspId) && selectedDspId?.length > 0
              ? item?.dspId === selectedDspId?.[0]
              : item?.dspId === String(selectedDspId)
      );

      return selectedDspAccount || selectedProfile?.dsp?.[0];
  }

  return selectedProfile?.dsp?.[0];
};

const ApiService = async (endpoint, method = 'GET', data = null, headers = {}, params = {}, isSendContentType = true, config = {}) => {
  const authToken = JSON.parse(localStorage.getItem('User')) || {};
  const identity = getUserIdentity(`${process.env.REACT_APP_HTTP_URL}/endpoint`);
  const getProfile = JSON.parse(sessionStorage.getItem('selectedProfileId'));
  const masterFilter = JSON.parse(sessionStorage.getItem('master-account-filters')) || {}

  const dspDetails = getProfile?.dsp ? getDspDetails(getProfile, masterFilter) :{};
  const userIdentity = {
    'X-USER-IDENTITY': identity,
    Authorization: `Bearer ${authToken?.token}`,
    'Amazon-Ads-AccountId': dspDetails?.dspId,
    'Amazon-Advertising-API-Scope': dspDetails?.agencyProfileId,
  }
  if (process.env.REACT_APP_DEMO_EMAIL.indexOf(authToken?.email) > -1) {
    const jsonString = await JSON.stringify({
      url: endpoint,
      method,
      data,
      params,
      headers: {
        ...(isSendContentType && { 'Content-Type': 'application/json' }),
        ...axiosInstance.defaults.headers,
        ...headers,
        ...userIdentity
      },
      ...config
    });
    const newString = await reverseReplaceString(jsonString);
    const newPayload = await JSON.parse(newString);
    const response = await axiosInstance(newPayload);
    return JSON.parse(replaceString(JSON.stringify(response)));
  } else {
    try {
    const response = await axiosInstance({
      url: endpoint,
      method,
      data,
      params,
      headers: {
        ...axiosInstance.defaults.headers,
        ...headers,
        ...userIdentity
      },
      ...config
    });
    return response;
  } catch (error) {
    console.error('API request failed:', error);
    if(error?.response?.data?.error_code === SESSION_EXPIRE_CODE){
      sweetAlertHandler({ type: 'alert', text: error?.response?.data?.message || 'User session has expired.', showConfirmButton: true })
    }
    return error
  }
  }
};

export default ApiService;
